module.exports = __webpack_public_path__ + "img/gorilla 5.jpg";